import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Control, Controller, useWatch } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type ClinicUpdaterProps = {
    control: Control<ScheduleActionFormData>;
    clinics: Array<any>;
    isUpdatingClinic: boolean;
    onUpdateClinic: () => void;
    onCancel: () => void;
};

export const ClinicUpdater = ({ control, clinics, isUpdatingClinic, onUpdateClinic, onCancel }: ClinicUpdaterProps) => {
    const targetClinicId = useWatch({ control, name: "targetClinicId" });

    return (
        <Box p={2}>
            <Controller
                name="targetClinicId"
                control={control}
                render={({ field }) => (
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="clinic-update-select-label">Clínica</InputLabel>
                        <Select
                            labelId="clinic-update-select-label"
                            label="Clínica"
                            value={field.value || ""}
                            name={field.name}
                            onBlur={field.onBlur}
                            onChange={(e) => field.onChange(e.target.value as number)}
                            inputRef={field.ref}
                        >
                            {clinics?.map((clinic: any) => (
                                <MenuItem key={clinic.id} value={clinic.id}>
                                    {clinic.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            />

            <Button
                fullWidth
                variant="contained"
                size="small"
                onClick={onUpdateClinic}
                disabled={isUpdatingClinic || !targetClinicId}
                sx={{ mb: 1 }}
            >
                {isUpdatingClinic ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
                Atualizar Clínica
            </Button>
            <Button fullWidth color="secondary" size="small" onClick={onCancel}>
                Cancelar
            </Button>
        </Box>
    );
};

